import { GenIcon } from '../helpers/IconBase.es.js';

const RamOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 11.6114V9.75C6 9.33579 6.33579 9 6.75 9C7.16421 9 7.5 9.33579 7.5 9.75V11.6114C7.5 12.0256 7.16421 12.3614 6.75 12.3614C6.33579 12.3614 6 12.0256 6 11.6114ZM9.5 11.6114V9.75C9.5 9.33579 9.83579 9 10.25 9C10.6642 9 11 9.33579 11 9.75V11.6114C11 12.0256 10.6642 12.3614 10.25 12.3614C9.83579 12.3614 9.5 12.0256 9.5 11.6114ZM13 9.75V11.6114C13 12.0256 13.3358 12.3614 13.75 12.3614C14.1642 12.3614 14.5 12.0256 14.5 11.6114V9.75C14.5 9.33579 14.1642 9 13.75 9C13.3358 9 13 9.33579 13 9.75ZM16.5 11.6114V9.75C16.5 9.33579 16.8358 9 17.25 9C17.6642 9 18 9.33579 18 9.75V11.6114C18 12.0256 17.6642 12.3614 17.25 12.3614C16.8358 12.3614 16.5 12.0256 16.5 11.6114Z",
          fill: "#82869E"
        }
      },
      {
        tag: "rect",
        attr: {
          x: "2.75",
          y: "6.75",
          width: "18.5",
          height: "7.5",
          rx: "1.25",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round"
        }
      },
      {
        tag: "line",
        attr: {
          x1: "2.75",
          y1: "17.25",
          x2: "7.25",
          y2: "17.25",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round"
        }
      },
      {
        tag: "line",
        attr: {
          x1: "10.75",
          y1: "17.25",
          x2: "21.25",
          y2: "17.25",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round"
        }
      }
    ]
  })(props);
};

export { RamOutlined };
